import React from "react";

import { ROUTES } from "routers/shared/util/consts";
import Link from "shared/components/Link";
import Str from "shared/components/Str";

import "./LoggedOut.scss";

const LoggedOut = () => (
	<div className="loggedOut">
		<Link className="loggedOut-login" to={ROUTES.SplashLogin[0]}>
			<Str>Log In</Str>
		</Link>
		<Link className="loggedOut-signup" to={ROUTES.Signup[0]}>
			<Str>Join now</Str>
		</Link>
	</div>
);

export default LoggedOut;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/LoggedOut.jsx